import axios from '../../axios'
export const getWebsiteList = (data) => {
    return axios({
        url: '/api/base/website',
        method: 'get',
        data
    })
}

export const addWebsiteInfo = (data) => {
    return axios({
        url: '/api/base/website',
        method: 'post',
        data
    })
}

export const editWebsiteInfo = (data) => {
    return axios({
        url: '/api/base/website',
        method: 'put',
        data
    })
}

export const delWebsiteInfo = (data) => {
    return axios({
        url: '/api/base/website',
        method: 'delete',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/wish/website.js